export function printEmail(html) {
  if (!html || html === '<p></p>') {
    alert('Não há conteúdo no e-mail para imprimir.');
    return;
  }

  const printHtml = `<!DOCTYPE html>
<html lang="pt-BR">
<head>
  <meta charset="utf-8" />
  <title>Orçamento</title>
  <style>
    @page { margin: 16mm; }
    *, *::before, *::after { box-sizing: border-box; }
    html, body {
      margin: 0;
      padding: 0;
      background: #fff;
      color: #172b4d;
      font-family: Montserrat, Arial, Helvetica, sans-serif;
      font-size: 14px;
      line-height: 1.45;
    }
    body {
      padding: 24px;
      page-break-before: avoid;
    }
    table {
      border-collapse: collapse;
      max-width: 100%;
      page-break-inside: auto;
    }
    tr { page-break-inside: auto; page-break-after: auto; }
    td, th { vertical-align: middle; }
    img { max-width: 100%; height: auto; }
    p { margin: 0 0 0.75em; }
    @media print {
      * { page-break-before: auto !important; page-break-after: auto !important; }
    }
  </style>
</head>
<body>${html}</body>
</html>`;

  const iframe = document.createElement('iframe');
  iframe.setAttribute('title', 'Pré-visualização de impressão do e-mail');
  iframe.style.cssText =
    'position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden';
  document.body.appendChild(iframe);

  const printFrame = iframe.contentWindow;
  const printDoc = printFrame?.document;
  if (!printFrame || !printDoc) {
    iframe.remove();
    alert('Não foi possível abrir a visualização de impressão.');
    return;
  }

  printDoc.open();
  printDoc.write(printHtml);
  printDoc.close();

  const runPrint = () => {
    printFrame.focus();
    printFrame.print();
    window.setTimeout(() => {
      iframe.remove();
    }, 1000);
  };

  const waitForImages = () => {
    const images = Array.from(printDoc.images);
    if (images.length === 0) {
      window.setTimeout(runPrint, 300);
      return;
    }

    const promises = images.map((image) => {
      if (image.complete) {
        if (image.decode) {
          return image.decode().catch(() => {});
        }
        return Promise.resolve();
      }
      return new Promise((resolve) => {
        image.addEventListener('load', () => resolve(), { once: true });
        image.addEventListener('error', () => resolve(), { once: true });
      });
    });

    Promise.all(promises).then(() => {
      window.setTimeout(runPrint, 100);
    });
  };

  if (printDoc.readyState === 'complete') {
    waitForImages();
  } else {
    iframe.onload = () => waitForImages();
  }
}
